import { AdminSettings, Customer, ZohoEstimateSummary, ZohoInvoiceSummary } from '../types';

export const resolveZohoCurrency = (
  settings: AdminSettings,
  customer: Customer,
  finance?: { invoices?: ZohoInvoiceSummary; estimates?: ZohoEstimateSummary } | null
) => {
  return (
    finance?.invoices?.currencyCode ||
    finance?.estimates?.currencyCode ||
    customer.zohoCurrencyCode ||
    settings?.defaultCurrency ||
    'USD'
  );
};
